import React from "react";
import UseTitle from "../Hooks/UseTitle";
import offerUpcoming from "../../Assets/Hompage/upcoming.png";
import { Link } from "react-router-dom";
const SpecialOffers = () => {
  UseTitle("Offer");
  return (
    <div className="max-w-screen-xl mx-auto">
      <div className="">
        <div className="flex items-center justify-center h-screen">
          <div>
            <img src={offerUpcoming} alt="" className="" />
            <div className="flex justify-center">
              <p className="text-white bg-[#b85033] px-10 py-5 text-xl font-bold text-center w-80 rounded-2xl">
                <Link to="/Online_Booking">Booking Now</Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SpecialOffers;
